// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__4cvbT","admins":"style_admins__2CaFL","slackImage":"style_slackImage__3IJGY"};